/* eslint-disable */

/**
 * 处理商品营销tag信息
 * @param { item } json // 商品信息
 * @param { tagList } array  // 标签列表
 * @return { item }  拼接信息后的商品信息
 */
export function dealTagGoods(item, tagList) {
  if (tagList && tagList.length > 0) {
    const goodTag = tagList.find(
      tag => (tag.categoryId == item.categoryId) && (tag.goodsId == item.goodsId)
    ) || {}
    const tags = goodTag && goodTag.tags ? goodTag.tags : []
    const promPrice = goodTag && goodTag.tags ? goodTag.promPrice : null
    const salePrice = goodTag && goodTag.salePrice ? goodTag.salePrice : null
    const bizStock = goodTag && goodTag.bizStock

    item.tags = tags
    // 只匹配满减特价抢购标签
    // item.tags = tags.filter(
    //     (item) => item.type === 1
    //   );
    
    // promoStickerInfo:爆炸贴数据   hasPromoSticker:是否含有爆炸贴
    item.promoStickerInfo = []
    item.hasPromoSticker = false
    tags &&
      tags.length > 0 &&
      tags.map((info, i) => {
        // type 1、促销 2、爆炸贴 3、新品
        if (info.type === 2) {
          item.promoStickerInfo.push(info)
          item.hasPromoSticker = true
        }
      })
    item.promPrice = promPrice
    item.salePrice = salePrice
    item.bizStock = bizStock
    // 业务库存为0 即使大库有库存，商品亦不可加购 业务库存>0 即使大库存为0 商品亦可加购
    if (item.bizStock === 0) {
      item.gray = true
    } else if (item.bizStock > 0) {
      item.gray = false
    }
    // 折扣信息
    item.discount = goodTag.discount
    item.discountPrice = goodTag.discountPrice
    item.discountTagShow = goodTag.discountTagShow
    item.mktTagShow = goodTag.mktTagShow

    // 福拼拼相关字段
    // Y 为福拼拼
    item.groupItem = goodTag.groupItem;
    // groupItemClassStyle 样式 1、文本模式，2、+货币模式
    item.groupItemClassStyle = goodTag.groupItemClassStyle;
    // 拼团价格
    item.groupItemPrice = goodTag.groupItemPrice;
    // 拼团价格限制 最高可抵扣福豆
    item.groupItemPriceLimit = goodTag.groupItemPriceLimit;
    // 拼团商品是否显示人命币 Y:是 N:否
    item.groupItemShowRmbSymbol = goodTag.groupItemShowRmbSymbol;
  }
  return item
}

/**
 * 处理商品营销tag图标展示
 * @param { item } json // 商品信息
 */
export function tagShow(item, limitFlag) {
  let flag = false
  // mktIcon 特价、限购、新品 || limitFlag && mktFrontType限购起购 || 300001抽奖
  if (item.mktIcon || (limitFlag && (item.mktFrontType === 9003 || item.mktFrontType === 9004))) {
    flag = true
  }
  return flag
}

/**
 * 处理商品生日牌信息
 * @param { goodsList } array // 商品信息
 * @return { newBirthdayInfoList }  当前商品列表同级的生日牌汇总信息
 */
export function getBirthdayInfoList(goodsList){
  let birInfoList = [{
    goodsList: [],
    index: 0,
    warehouseId: 0,
    warehouseNo: '',
  }];
  let newBirthdayInfoList = [];
  goodsList &&
    goodsList.map(item => {
      const sessionBirthdayInfoList = JSON.parse(window.sessionStorage.getItem('birthdayInfoList')) || [];
      if (sessionBirthdayInfoList && sessionBirthdayInfoList.length > 0) {
        sessionBirthdayInfoList.forEach(a => {
          a.goodsList && a.goodsList.length > 0 && a.goodsList.forEach(b => {
            if (b.categoryId == item.categoryId && b.goodsId == item.goodsId) {
              birInfoList[0].index = a.index;
              birInfoList[0].warehouseId = a.warehouseId;
              birInfoList[0].warehouseNo = a.warehouseNo;
              birInfoList[0].goodsList.push({
                goodsId: item.goodsId,
                categoryId: item.categoryId,
                birthdayRemark: b.birthdayRemark,
              });
              newBirthdayInfoList = birInfoList;
            }
          });
        });
        return newBirthdayInfoList;
      } else {
        return newBirthdayInfoList;
      }
    });
}

/**
 * 处理配件加购后的，配件总数量
 * @param { list } array // 商品信息
 * @return { num }  配件总数量
 */
export function getPartsNum(list) {
  let num = 0;
  if (list && list.length > 0) {
    list.forEach(ele => {
      ele.warehouseList && ele.warehouseList.length > 0 && ele.warehouseList.forEach(item => {
        if (item.annexTotalNum) {
          num = num + item.annexTotalNum;
          return num
        }
      })
    })
  }
  return num;
}